/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_No_Partners_BodyInputs */



/**
* | output |
* | --- |
* | "Create your first partner to get started." |
*
* @param {Partner_Admin_No_Partners_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_no_partners_body = /** @type {((inputs?: Partner_Admin_No_Partners_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_No_Partners_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Legen Sie Ihren ersten Partner an, um zu starten.")
	return /** @type {LocalizedString} */ ("Create your first partner to get started.")
});